// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2bvFm","tiles":"styles_tiles__Qxukq","shopTitle":"styles_shopTitle__1ahDD","tileImg":"styles_tileImg__2XJfw"};